import React from 'react';
import OrderBook from "../demat/OrderBook";
import {Grid, Typography} from "@mui/material";
import Positions from "../demat/Positions";

const FNOUser = ({user, userId, userName}) => {
  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item xs={12} md={12}>
        <Typography variant="h6">{userName}({userId}) Profile</Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <Positions loggedInUser={user} selectedUserId={userId} source={'fno'} straddles={[]}/>
      </Grid>
      <Grid item xs={12} md={12}>
        <OrderBook user={user} userId={userId}/>
      </Grid>
    </Grid>
  )
}

export default FNOUser;